<div class="flex flex-col report-issue-dialog">
  <app-sidenav-header [subtitle]="subtitle" [title]="title"></app-sidenav-header>

  <form [formGroup]="reportIssueForm">
    <div class="flex flex-col">
      <div class="flex-col form-field">
        <div class="flex flex-row mb-10">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.SERVICE' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div class="mat-body-1">
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}</div>
            <div>{{report?.service.name}}</div>
          </div>
          <div class="flex flex-row mb-20">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.VERSION' | transloco}}</div>
            <div>{{report?.service.version || ('INSTANCE_SUMMARY.NA' | transloco)}}</div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-10">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.BLUEPRINT' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div class="mat-body-1">
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}</div>
            <div>{{report?.blueprint.name}}</div>
          </div>
          <div class="flex flex-row mb-20">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.VERSION' | transloco}}</div>
            <div>{{report?.blueprint.version || ('INSTANCE_SUMMARY.NA' | transloco)}}</div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-10">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.INSTANCE' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" matTooltip="" matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <div class="mat-body-1">
          <div class="flex flex-row mb-6">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.NAME' | transloco}}</div>
            <div>{{report?.instance.name}}</div>
          </div>
          <div class="flex flex-row mb-20">
            <div class="fw-700 mr-4">{{'INSTANCE_SUMMARY.REPORT_ISSUE.VERSION' | transloco}}</div>
            <div>{{report?.instance.configurationId && (configurations | find : 'id' : report?.instance.configurationId)
              ? (configurations | find : 'id' : report?.instance.configurationId)['version'] + '/' + (configurations | find : 'id' : report?.instance.configurationId)['status']
              : ('INSTANCE_SUMMARY.NA' | transloco)}}
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col form-field">
        <div class="flex flex-row mb-4">
          <label>{{'INSTANCE_SUMMARY.REPORT_ISSUE.ISSUE_DESCRIPTION' | transloco | uppercase}}</label>
          <mat-icon svgIcon="info" matTooltip="" matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          <mat-icon svgIcon="info" class="info-icon ml-10" matTooltip="" matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <textarea class="pt-12 h-136" formControlName="description" required>
        </textarea>
        <app-error [control]="reportIssueForm.get('description')"></app-error>
      </div>
    </div>
  </form>

  <span class="flex-auto"></span>

  <mat-divider class="mb-32"></mat-divider>

  <ng-container>
    <div class="flex-row gap-x-4" dir="rtl">
      <button (click)="reportIssue()" class="accent" type="button">{{'BUTTONS.REPORT' | transloco}}</button>
      <button (click)="sidenavService.closeRightSidenav()" class="white"
              type="button">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </ng-container>
</div>
